const USER_EMAIL_KEY = "userEmail";

export function setUserEmailToLocalStorage(userEmail) {
    localStorage.setItem(USER_EMAIL_KEY,userEmail);
}

export function getUserEmailFromLocalStorage() {
    return localStorage.getItem(USER_EMAIL_KEY);
}

export function deleteUserEmailFromLocalStorage() {
    localStorage.removeItem(USER_EMAIL_KEY);
}


// WEBPACK FOOTER //
// ./src/Firebase/localStorageForUserInfo.js